import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { PaperMaterialInventoriesPermission } from "commons/enum/permission";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import {
  AddButton,
  ExportExcelButton,
} from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { AddPaperGoodsIssue } from "../add-goods-issue/add-goods-issue";
import { PaperMaterialGroupSelectionConnected } from "../share";
import { UpdatePaperGoodsIssue } from "../update-goods-issue/update-goods-issue";
import { ExportExcel } from "./export-excel/export-excel";
import { PaperGoodsIssueTable } from "./paper-goods-issue-table";

export const PaperGoodsIssueList = observer(() => {
  const {
    paperInventoryManagement: {
      paperGoodsIssueStore: {
        setProp,
        pagination,
        getPaperGoodsIssue,
        openNew,
        openEdit,
        openExportExcel,
        queryParams: {
          dateRangeFilter: {
            fromAsDayJs,
            toAsDayJs,
            setProp: setDateRangeProps,
          },
          gsm,
          type,
          code,
          brand,
          specificationSize,
          rollNumber,
          setProp: setQueryParamProps,
          showZeroQuantity,
        },
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getPaperGoodsIssue();
  }, [getPaperGoodsIssue, pagination]);

  const fromDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("from", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const toDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setDateRangeProps("to", value ? value.toString() : null);
    },
    [setDateRangeProps],
  );

  const showZeroQuantityHandler = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setQueryParamProps("showZeroQuantity", checked);
      await getPaperGoodsIssue();
    },
    [getPaperGoodsIssue, setQueryParamProps],
  );

  return (
    <>
      <PageFilterContainer
        direction={"row"}
        justifyContent={"space-between"}
        padding={"10px 0"}
      >
        <Stack
          direction={"row"}
          spacing={1}
          flex={1}
          alignItems={"center"}
          flexWrap={"wrap"}
          rowGap={"10px"}
        >
          <DateRange
            label={"Ngày xuất"}
            fromDate={fromAsDayJs}
            toDate={toAsDayJs}
            onFromDateChanged={fromDateChangedHandler}
            onToDateChanged={toDateChangedHandler}
          ></DateRange>
          <PaperMaterialGroupSelectionConnected
            codeSelected={code}
            specificationSizeSelected={specificationSize}
            brandSelected={brand}
            rollNumberSelected={rollNumber}
            typeSelected={type}
            gsmSelected={gsm}
            setSelectionProp={setQueryParamProps}
          />
          <SearchButton asyncAction={onSearch}></SearchButton>
        </Stack>
      </PageFilterContainer>
      <Stack direction={"row"} justifyContent={"right"} spacing={1}>
        <Box>
          <ExportExcelButton
            accessPermission={[
              PaperMaterialInventoriesPermission.ExportExcelByRollNumber,
            ]}
            onClick={() => {
              setProp("openExportExcel", true);
            }}
          ></ExportExcelButton>
        </Box>
        <Box>
          <AddButton
            accessPermission={[PaperMaterialInventoriesPermission.IssueCreate]}
            onClick={() => {
              setProp("openNew", true);
            }}
          >
            Thêm xuất kho
          </AddButton>
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              checked={showZeroQuantity}
              onChange={showZeroQuantityHandler}
            />
          }
          label="Gồm tồn bằng 0"
        />
      </Stack>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <PaperGoodsIssueTable></PaperGoodsIssueTable>
      </PageContentContainer>

      <>
        {openNew && <AddPaperGoodsIssue></AddPaperGoodsIssue>}
        {openEdit && <UpdatePaperGoodsIssue></UpdatePaperGoodsIssue>}
        {openExportExcel && <ExportExcel></ExportExcel>}
      </>
    </>
  );
});
